document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-root-discovery-pdp]');
  if (!root) return;

  var mainImage = root.querySelector('[data-root-main-image]');
  var gallery = root.querySelector('.root-pdp-main-image');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-root-thumb]'));
  var currentImageIndex = 0;
  var imageSwapTimer = null;

  thumbs.forEach(function (thumb, index) {
    if (thumb.classList.contains('is-active')) currentImageIndex = index;
  });

  function updateThumbState(index) {
    thumbs.forEach(function (item, itemIndex) {
      item.classList.toggle('is-active', itemIndex === index);
    });
  }

  function updateGalleryCount() {
    var countCurrent = root.querySelector('[data-root-gallery-current]');
    if (countCurrent) countCurrent.textContent = currentImageIndex + 1;
  }

  function showImage(nextIndex, direction) {
    if (!mainImage || !thumbs.length) return;

    currentImageIndex = (nextIndex + thumbs.length) % thumbs.length;
    var thumb = thumbs[currentImageIndex];
    var src = thumb.getAttribute('data-full');
    var alt = thumb.getAttribute('data-alt') || '';
    if (!src) return;

    window.clearTimeout(imageSwapTimer);
    mainImage.classList.remove('is-gallery-prev', 'is-gallery-next');
    mainImage.classList.add(direction < 0 ? 'is-gallery-prev' : 'is-gallery-next');
    mainImage.classList.add('is-gallery-changing');

    imageSwapTimer = window.setTimeout(function () {
      mainImage.src = src;
      mainImage.alt = alt;
      updateThumbState(currentImageIndex);
      updateGalleryCount();

      window.requestAnimationFrame(function () {
        mainImage.classList.remove('is-gallery-changing', 'is-gallery-prev', 'is-gallery-next');
      });
    }, 90);
  }

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      showImage(index, index < currentImageIndex ? -1 : 1);
    });
  });

  if (gallery && mainImage && thumbs.length > 1) {
    gallery.setAttribute('tabindex', '0');
    gallery.setAttribute('role', 'region');
    gallery.setAttribute('aria-label', 'Product image gallery');

    var previousButton = document.createElement('button');
    previousButton.type = 'button';
    previousButton.className = 'root-pdp-gallery-arrow root-pdp-gallery-arrow--prev';
    previousButton.setAttribute('aria-label', 'Previous product image');
    previousButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'root-pdp-gallery-arrow root-pdp-gallery-arrow--next';
    nextButton.setAttribute('aria-label', 'Next product image');
    nextButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var count = document.createElement('div');
    count.className = 'root-pdp-gallery-count';
    count.setAttribute('aria-live', 'polite');
    count.innerHTML = '<span data-root-gallery-current>' + (currentImageIndex + 1) + '</span> / ' + thumbs.length;

    gallery.appendChild(previousButton);
    gallery.appendChild(nextButton);
    gallery.appendChild(count);

    previousButton.addEventListener('click', function (event) {
      event.preventDefault();
      showImage(currentImageIndex - 1, -1);
    });

    nextButton.addEventListener('click', function (event) {
      event.preventDefault();
      showImage(currentImageIndex + 1, 1);
    });

    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(currentImageIndex - 1, -1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(currentImageIndex + 1, 1);
      }
    });

    var touchStartX = 0;
    var touchStartY = 0;

    gallery.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    gallery.addEventListener('touchend', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      var deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

      if (deltaX < 0) showImage(currentImageIndex + 1, 1);
      else showImage(currentImageIndex - 1, -1);
    }, { passive: true });
  }

  var qtyInput = root.querySelector('[data-root-qty-input]');
  var qtyDisplays = document.querySelectorAll('[data-root-qty-display]');
  function setQty(next) {
    if (!qtyInput) return;
    var min = parseInt(qtyInput.getAttribute('min') || '1', 10);
    next = Math.max(min, parseInt(next || min, 10));
    qtyInput.value = next;
    qtyDisplays.forEach(function (display) { display.textContent = next; });
  }

  document.querySelectorAll('[data-root-qty-minus]').forEach(function (button) {
    button.addEventListener('click', function () { setQty((parseInt(qtyInput && qtyInput.value, 10) || 1) - 1); });
  });
  document.querySelectorAll('[data-root-qty-plus]').forEach(function (button) {
    button.addEventListener('click', function () { setQty((parseInt(qtyInput && qtyInput.value, 10) || 1) + 1); });
  });
  if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

  var form = root.querySelector('[data-root-product-form]');
  document.querySelectorAll('[data-root-sticky-submit]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!form) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  });
});
